import {useEffect, useState} from 'react';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {debounce} from 'lodash';
import {getBreweriesACS} from 'store/breweries/requestAC';

import {BeerDropdown} from '../ListBeers/BeerDropdown';
import {getAllBeersACS, getPubBeersACS} from '../requestAC';
import {setAllBeersAC, setAllBeersFilterAC} from '../slice';
import Table from '../Table/Table';

import './ManageBeers.scss';

const ManageBeers = () => {
  const dispatch = useSetGlobalState();
  const {managedPub} = useGlobalState((state) => state.managedPub);
  const {pubBeers, allBeers, beerTotalPages, pubBeerFilters, allBeerFilter} = useGlobalState(
    (state) => state.beersManager,
  );
  const {filters: breweryFilters} = useGlobalState((state) => state.breweries);

  const [isInputFocused, setIsInputFocused] = useState(false);

  const handleSearch = debounce((value: string) => {
    if (!value && allBeers.length) dispatch(setAllBeersAC([]));
    dispatch(setAllBeersFilterAC({...allBeerFilter, name: value, page: 1}));
  }, 500);

  useEffect(() => {
    if (!managedPub) return;

    dispatch(getPubBeersACS({pubId: managedPub.id, ...pubBeerFilters}));
    dispatch(getBreweriesACS({...breweryFilters, perPage: 100, isForBeers: true}));
    // eslint-disable-next-line
  }, [managedPub, pubBeerFilters.page, pubBeerFilters.perPage, breweryFilters]);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setIsInputFocused(false);
  });

  const getNextPageItems = (page: number) => {
    if (beerTotalPages === page) return;

    dispatch(setAllBeersFilterAC({...allBeerFilter, page: page + 1}));
  };

  useEffect(() => {
    dispatch(getAllBeersACS(allBeerFilter));
    // eslint-disable-next-line
  }, [allBeerFilter]);
  useEffect(() => {
    return () => {
      dispatch(setAllBeersFilterAC({page: 1, perPage: 8, name: ''}));
      dispatch(setAllBeersAC([]));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="beers-manage">
      {isInputFocused && <div className="beers-manage__curtain" />}
      <div className="beers-manage__header">
        <div className="beers-manage__items-wrapper">
          <div className="beers-manage__items-container" ref={containerRef}>
            <div className="search">
              <input
                onFocus={() => setIsInputFocused(true)}
                className="search__field"
                placeholder={`${isInputFocused ? 'Type to find beers...' : 'Start typing or select beers'}`}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <Icon icon="chevron-down" />
            </div>
            {isInputFocused && (
              <BeerDropdown
                className="beers-manage__items"
                getNextPageItems={getNextPageItems}
                beersDropdownPage={allBeerFilter.page}
                beerTotalPages={beerTotalPages}
                allBeers={allBeers}
                search={allBeerFilter.name}
              />
            )}
          </div>
        </div>
      </div>
      <div className="beers-manage__table">
        <Table beersList={pubBeers} />
      </div>
    </div>
  );
};

export default ManageBeers;
